import React from 'react';

type Props = {
  text?: string;
  align?: 'left' | 'center' | 'right';
  color?: string; // tailwind text color class e.g. 'text-gray-900'
  shadow?: boolean;
  fontFamily?: string;
};

const HeadingOverlay: React.FC<Props> = ({
  text = 'Your Heading',
  align = 'left',
  color = 'text-gray-900',
  shadow = true,
  fontFamily,
}) => {
  const alignClass = align === 'center' ? 'text-center' : align === 'right' ? 'text-right' : 'text-left';
  return (
    <div className={`${alignClass} ${color}`} style={fontFamily ? { fontFamily } : undefined}>
      <h2 className={`font-bold tracking-tight text-3xl md:text-4xl ${shadow ? 'drop-shadow-[0_1px_1px_rgba(0,0,0,0.25)]' : ''}`}>
        {text}
      </h2>
    </div>
  );
};

export default HeadingOverlay;
